export const CHARACTERISTICS = 'characteristics';
export const DOCUMENTS = 'documents';
export const SOFTWARE = 'software';

export const TABS_ID = {
  characteristics: CHARACTERISTICS,
  documents: DOCUMENTS,
  software: SOFTWARE,
};

export const enum EPriceSpiderName {
  DEFAULT = 'B2C price spider widget',
  PRIVATE = 'B2B price spider widget',
}

export const enum ECustomerType {
  CLASSIFICATION1 = 'ATG_CLASSVALUE1',
}

export const enum EPriceSpiderKey {
  // PUBLIC and LEGACY keys moved from APC codebase
  PUBLIC = '5bbf65a04a17ef05e8d8a0ae',
  LEGACY = '5900be5a8196951772ce423f',
  // PRIVATE key copied from PriceSpider documentation
  PRIVATE = '65304d2283d990000e23ce8c',
}

export enum ESustainabilityType {
  GREEN_PREMIUM = 'GREEN_PREMIUM',
  DEFAULT = 'DEFAULT',
}

export enum ESustainabilityGroupType {
  DEFAULT = 'DEFAULT',
  PRIMARY = 'PRIMARY',
}

export enum ECarouselRelation {
  crossSellLife = 'crossSellLife',
  crosssell = 'crosssell',
  upsell = 'upsell',
  Compatiblesoftware = 'Compatiblesoftware',
  compatibleSoftware = 'compatibleSoftware',
}
